import React from 'react'

export default function MailIcon() {
   return (
      <svg
         width="49"
         height="49"
         viewBox="0 0 49 49"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.2773 0.550293C37.5322 0.550293 48.2773 11.2955 48.2773 24.5503C48.2773 37.8051 37.5322 48.5503 24.2773 48.5503C11.0225 48.5503 0.277344 37.8051 0.277344 24.5503C0.277344 11.2955 11.0225 0.550293 24.2773 0.550293ZM39.5117 33.8541V16.017L30.5926 24.9355L39.5117 33.8541ZM10.9483 34.2175H37.6069L29.4593 26.0699L26.354 29.1747C26.2034 29.3249 25.9995 29.4092 25.7868 29.4091H22.7681C22.6627 29.4092 22.5584 29.3885 22.4611 29.3483C22.3638 29.3081 22.2753 29.2491 22.2008 29.1747L19.0956 26.0699L10.948 34.2175H10.9483ZM9.04297 16.0164V33.8546L17.9621 24.9355L9.04297 16.0164ZM38.3779 14.8831H10.1773L23.1002 27.8059H25.4549L38.3779 14.8831Z"
            fill="#F1ECDC"
         />
      </svg>
   )
}
